// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"styles_logoContainer__3mGm-"};